// Traduções deste componente — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'layout.topbar.openMenu': 'Abrir menu',
    'layout.topbar.account': 'Conta',
  },
  en: {
    'layout.topbar.openMenu': 'Open menu',
    'layout.topbar.account': 'Account',
  },
  es: {
    'layout.topbar.openMenu': 'Abrir menú',
    'layout.topbar.account': 'Cuenta',
  },
}
